import React from 'react';
import Icon from './Icon';

const cards = [
  {
    kind: 'book',
    icon: 'calendar',
    title: 'Booking',
    sub: 'The AI books the call on your calendar of record, never a slot negotiated in the DM.',
    chips: ['Calendly', 'iClosed', 'Cal.com']
  },
  {
    kind: 'crm',
    icon: 'link',
    title: 'CRM & automations',
    sub: 'Every qualified conversation and booked call flows into your CRM, natively or through Zapier & our API.',
    chips: ['HubSpot', 'GoHighLevel', 'Pipedrive', 'Notion', 'Zapier & API']
  }
];

function Integrations() {
  return (
    <section id="integrations" style={{ paddingTop: 0 }}>
      <div className="wrap">
        <div className="sec-head">
          <div className="eyebrow">Plugs into your stack</div>
          <h2>Books on your calendar. Syncs to your CRM.</h2>
          <p>Salesyo doesn't replace your tools, it feeds them. It books straight into the scheduler you already use, and pushes every qualified lead into your CRM.</p>
        </div>
        <div className="intg-grid">
          {cards.map((c) => (
            <div className={`intg-card ${c.kind}`} key={c.title}>
              <div className="ih"><span className="ic2"><Icon name={c.icon} size={20} /></span><h3>{c.title}</h3></div>
              <div className="isub">{c.sub}</div>
              <div className="intg-chips">
                {c.chips.map((chip) => (
                  <span className="intg-chip" key={chip}><span className="dotc"></span>{chip}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Integrations;
